export const isInterfaceStereotype = (code: string) =>
	['db_link_generic', 'file_table_mapping'].includes(code)
